import React from 'react';
import { LocalizeProvider } from 'react-localize-redux';
import { Provider } from 'react-redux';
import { showAlert } from './stores/alerts/actionCreators';
import store, { browserHistory } from './stores/store';

import { ConnectedRouter } from 'connected-react-router';
import AlertContainer from './components/alerts/AlertContainer';
import { Routes } from './routing/Routes';

import './App.scss';
import queryString from 'query-string';
import { setAuthReqSource } from './stores/auth/actionCreators';

interface State {
    hasError: boolean;
}

class App extends React.Component<{}, State> {

    public static getDerivedStateFromError(error: Error) {
        // Update state so the next render will show the fallback UI.
        return { hasError: true };
    }

    public componentDidCatch(error: Error, info: React.ErrorInfo) {
        // tslint:disable-next-line:no-console
        console.error(error, error.stack, info.componentStack);
        store.dispatch(showAlert({
            color: 'danger',
            message: 'An unexpected error occured!',
            title: 'Error',
            type: 'error',
        }));
    }
    
    componentDidMount() {
        const values = queryString.parse(window.location.search);
        // check if we should return to a specific process
        if (typeof values.application === 'string') {
            let query = "";
            Object.keys(values).forEach(k => {
                if (k === 'application') return;
                query += '&' + k + '=' + values[k];
            })
            store.dispatch(setAuthReqSource(
                '', '', values.application, query
            ));
        }
        // get the task and callback url from the query
        if (typeof values.task === 'string') {
            store.dispatch(setAuthReqSource(values.task, typeof values.url === 'string' ? decodeURIComponent(escape(values.url)) : ''));
        }
    }

    constructor(props: {}) {
        super(props);
        this.state = {
            hasError: false,
        };
    }

    public render() {
        if (this.state.hasError) {
            return (
                <LocalizeProvider store={store}>
                    <Provider store={store}>
                        <AlertContainer />
                    </Provider>
                </LocalizeProvider>
            );
        }
        return (
            <LocalizeProvider store={store}>
                <Provider store={store}>
                    <ConnectedRouter history={browserHistory}>
                        <Routes />
                    </ConnectedRouter>
                </Provider>
            </LocalizeProvider>
        );
    }
}

export default App;